import {get,get_res,post,post_res,delete_api} from '../http.js'
import Vue from 'vue'

	let baseURL = "http://www.tpahw.com"
			if (window.location.href.indexOf('.com') > -1) {
				baseURL = "http://www.tpahw.com"
			} else {
				baseURL = 'http://www.tpahw.cn'
			}
Vue.prototype.$baseURL = baseURL
			
export default {
	formatDate: function (date) {
	  var date = new Date(date);
	  var YY = date.getFullYear() + '-';
	  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
	  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
	  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
	  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
	  return YY + MM + DD +" "+hh + mm + ss;
	},
	
	// 手机号码
	isMobile: (s) => {
		return /^1[0-9]{10}$/.test(s)
	}, 
	// 邮箱
	isEmail: (s) => {
	  return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
	},
	
	// 判断token有无过期
	checkToken: async function () {
		let _this = this
		const res = await get('/checkToken.do',{stamp: '1612161266390', v_stamp: '1612161266390'})
		return res
	},
	
	// 获取资源详情的浏览量
	lookCount: async function (docId) {
		let _this = this
		const res = await get_res('/members/browsecount',{sld: 'AHSCXB', docId})
		return res
	},
	
	// 获取下载量
	uoloadCount: async function (docId) {
		let _this = _this
		const res = await get_res('/members/getDownloadsNum', {docId})
		return res
	},
	
	// 获取资源详情的收藏量
	collectCount: async function (docId) {
		let _this = this
		const res = await get_res('/members/collectcount',{sld: 'AHSCXB', docId})
		return res
	},
	
	// 判断是否收藏
	isCollect: async function (docId) {
		let _this = this
		const res_token = await this.checkToken()
		if (res_token.result==0) {
			return false
		}
		const res = await get_res('/members/isCollect',{sld: 'AHSCXB', docId})
		return res
	},
	
	// 收藏操作
	collect: async function (docLibId,docId) {
		let _this = this
		const res = await post_res('/members/collect?docLibId=' + docLibId + '&docId=' + docId + '&sld=AHSCXB')
		return res
	},
	
	
	// 收藏操作
	collect_del: async function (docLibId,docId) {
		let _this = this
		const res = await delete_api('/members/unCollectByDocId?docId=' + docId)
		return res
	},
	
	// 是否购买
	is_buy: async function (docLibId,docId) {
		let _this = this
		const res = await get('/spc/productAuth/product/mobileProductAuth.do?resourceId=' + docLibId)
		return res
	},
	
	showMsg (type, content, time, isclose) {
		if (type=='warning') {
			Vue.prototype.$Message.warning({
					content,
					duration: time,
					closable: isclose
			});
		}
		if (type=='error') {
			Vue.prototype.$Message.error({
					content,
					duration: time,
					closable: isclose
			});
		}
		if (type=='success') {
			Vue.prototype.$Message.success({
					content,
					duration: time,
					closable: isclose
			});
		}
	},
	
	/**
	 * 对象转URL
	 */
	urlEncode: function (data) {
		var _result = [];
		for (var key in data) {
			var value = data[key];
			if (value.constructor == Array) {
				value.forEach(_value => {
					_result.push(key + "=" + _value);
				});
			} else {
				_result.push(key + '=' + value);
			}
		}
		return _result.join('&');
	},
}